/*
 * @Descripttion: 
 * @version: 
 * @Author: ybac
 * @Date: 2023-04-03 14:02:01
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-05-12 14:50:18
 */
/** init domain config */
import Vue from 'vue'

const VUE_APP_API_BASE_URL = 'https://wc.mycrab.cn/jeecg-boot/';
const VUE_APP_CAS_BASE_URL = 'http://cas.example.org:8443/cas';
const VUE_APP_ONLINE_BASE_URL = 'https://wc.mycrab.cn:8102/onlinePreview';
//设置全局API_BASE_URL
Vue.prototype.API_BASE_URL = VUE_APP_API_BASE_URL
window._CONFIG = {}
window._CONFIG['domianURL'] = Vue.prototype.API_BASE_URL
//单点登录地址
window._CONFIG['casPrefixUrl'] = VUE_APP_CAS_BASE_URL
window._CONFIG['onlinePreviewDomainURL'] = VUE_APP_ONLINE_BASE_URL
window._CONFIG['staticDomainURL'] = Vue.prototype.API_BASE_URL + '/sys/common/static'
window._CONFIG['pdfDomainURL'] = Vue.prototype.API_BASE_URL + '/sys/common/pdf/pdfPreviewIframe'